var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 7.99926C15.9989 12.0392 13.0039 15.3792 9.11323 15.9212C8.74944 15.9716 8.37724 15.998 7.99944 15.998C7.56334 15.998 7.13509 15.9632 6.71805 15.8959C2.90919 15.2828 0 11.9804 0 7.99926C0 3.5815 3.58184 0 8 0C12.4182 0 16 3.5815 16 7.99926H15.9989Z",
    fill: "#2B2B2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11314 6.42519V8.16775H11.269L10.9276 10.5151H9.11314V15.9232C8.74936 15.9736 8.37716 16 7.99936 16C7.56326 16 7.13501 15.9652 6.71797 15.898V10.5151H4.72974V8.16775H6.71797V6.03566C6.71797 4.71291 7.79027 3.64014 9.11371 3.64014V3.64126C9.11763 3.64126 9.12099 3.64014 9.12492 3.64014H11.2695V5.67022H9.86819C9.45171 5.67022 9.11371 6.00819 9.11371 6.42463L9.11314 6.42519Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFFacebook);
export default __webpack_public_path__ + "static/media/f-facebook.708361af5e5ce8f3bab02112dc6ac3f3.svg";
export { ForwardRef as ReactComponent };